import React, { useEffect } from 'react'
import { useParams } from "react-router-dom";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import {
    UiButton,
} from "../../../../../_uiComponents/common/form/UiButton";
// import UiTableHead from '../../../../../_uiComponents/common/table/UiTableHead';
import UiTableHead from '../../../../../_uiMocks/_uiComponents/UiTableHead';

import { useDispatch, useSelector } from "react-redux";
import { incentiveContentUnPublishRequest } from '../../../../../../_redux/_actions';


export default function PublishedTable(props) {

    const {loadData,publishedData} = props;

    const { id } = useParams();
    const campaignId = parseInt(id);

    const actionDispatch = useDispatch();

    const headings = [
        { id: 'revision', name: 'Revision' },
        { id: 'publishedby', name: 'Published By' },
        { id: 'publishedon', name: 'Published On' },
        { id: 'reason', name: 'Reason' },
        { id: '', name: '' },

    ]


    const unPublishContent = (id) => {
        actionDispatch(
             incentiveContentUnPublishRequest({ contentId:id,campaignId:campaignId }),
        );
   };
   

    return (
        <>

            <div className='sba-table-main-wr sba-campaign-content-table-wr'>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650, mt: 0 }} aria-label="simple table" className='sbt-data-grid'>
                        <UiTableHead
                            headings={headings}
                        />
                        <TableBody>
                

                                   {(publishedData?.contentRevision&&publishedData?.contentRevision!=0)&& 
                                   <TableRow >
                                        <TableCell>
                                            {publishedData.contentRevision}
                                        </TableCell>
                                        <TableCell align="center">
                                            {publishedData.publishBy}
                                        </TableCell>
                                        <TableCell align="center">
                                            {publishedData.publishOn}
                                        </TableCell>
                                        <TableCell align="center">
                                            {publishedData.changeReason}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Stack
                                                spacing={2}
                                                direction="row"
                                                justifyContent="end"
                                                sx={{
                                                    width: "100%",
                                                }}
                                            >
                                                <UiButton
                                                    name="Load"
                                                    variant="contained"
                                                    size="small"
                                                    color="primary"
                                                    onClick={()=>{loadData(publishedData.id)}}
                                                />
                                                <UiButton
                                                    name="Unpublish"
                                                    variant="contained"
                                                    size="small"
                                                    color="error"
                                                    onClick={()=>{unPublishContent(publishedData.id)}}
                                                />
                                            </Stack>
                                        </TableCell>

                                    </TableRow>
                                    }
                                
                           
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>



        </>
    )
}
